{
  "name": "@tov-plus/guests",
  "private": true,
  "version": "0.0.100",
  "type": "module",
  "scripts": {
    "branding:generate": "tsx ../../tooling/scripts/generate-frontend-branding-assets.ts --app guests --mode development",
    "predev": "tsx ../../tooling/scripts/generate-frontend-branding-assets.ts --app guests --mode development",
    "prestart": "tsx ../../tooling/scripts/generate-frontend-branding-assets.ts --app guests --mode development",
    "prebuild": "tsx ../../tooling/scripts/generate-frontend-branding-assets.ts --app guests --mode production",
    "dev": "vite",
    "start": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "typecheck": "tsc -p tsconfig.json --noEmit",
    "test": "vitest run"
  },
  "dependencies": {
    "@fontsource-variable/fraunces": "^5.3.0",
    "@fontsource-variable/manrope": "^5.3.0",
    "@sentry/browser": "10.51.0",
    "@tov-plus/analytics": "workspace:*",
    "@tov-plus/assets": "workspace:*",
    "@tov-plus/capabilities": "workspace:*",
    "@tov-plus/config": "workspace:*",
    "@tov-plus/domain": "workspace:*",
    "@tov-plus/frontend-data": "workspace:*",
    "@tov-plus/observability": "workspace:*",
    "@tov-plus/publishing": "workspace:^0.0.0",
    "@tov-plus/pwa": "workspace:*",
    "@tov-plus/sdk": "workspace:*",
    "@tov-plus/ui": "workspace:*",
    "@tov-plus/utils": "workspace:*",
    "@zektec/environment-tag": "file:../../common-resources/packages/environment-tag",
    "@zektec/environment-utils": "file:../../common-resources/packages/environment-utils",
    "react": "^19.3.1",
    "react-dom": "^19.3.1"
  },
  "devDependencies": {
    "@types/react": "^19.0.10",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "vite": "^8.3.3"
  }
}
